import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import * as Icon from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../../core/data/redux/store';
import {
  createPartnerUser,
  updatePartnerUser,
  deletePartnerUser,
  getAllPartnerUsers,
} from '../../../../services/partnerServices';

import { rowdatas } from '../../../../core/models/interface';
import { Toast } from 'primereact/toast';
import { UserRoles } from '../../../../app/common/constants/userRoles';
import { getAllAdminUsers } from '../../../../services/adminServices';

const PartnersModal = ({
  selectedUser,
  setIsAddModalOpen,
  isAddModalOpen,
  isEditModalOpen,
  setIsEditModalOpen,
}: {
  selectedUser: any | null;
  setIsAddModalOpen: (value: boolean) => void;
  isAddModalOpen: boolean;
  isEditModalOpen: boolean;
  setIsEditModalOpen: (value: boolean) => void;
}) => {
  const toast = useRef<Toast>(null);
  const { partnerUserCreated, partnerUserUpdated, isError, errorMessage } =
    useSelector((state: any) => state.partner);
  const [partner, setPartner] = useState({
    first_name: '',
    last_name: '',
    email_address: '',
    phone_number: '',
    
  });
  const dispatch = useDispatch<AppDispatch>();
  
  
  const [updatedUser, setUpdatedUser] = useState<any>({
    id: selectedUser?.id || '',
    first_name: selectedUser?.first_name || '',
    last_name: selectedUser?.last_name || '',
    email_address: selectedUser?.email_address || '',
    phone_number: selectedUser?.phone_number || '',
    
  });
  
  const [isActive, setIsActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);


  const handleCreatePartnerUser = async (e: React.FormEvent) => {
    try {
      setIsLoading(true);
      console.log('handleCreatePartnerUser');

      e.preventDefault();

      await dispatch(createPartnerUser(partner, setIsAddModalOpen));
      setPartner({ first_name: '', last_name: '', email_address: '', phone_number: '' });
      setUpdatedUser({ first_name: '', last_name: '', email_address: '', phone_number: '' });
    } catch (error) {
      console.log('handleCreatePartnerUser error', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdatePartnerUser = (e: React.FormEvent) => {
    try {
      setIsLoading(true);
      e.preventDefault();
      if (selectedUser) {
        dispatch(
          updatePartnerUser(
            selectedUser.id,
            {
              ...updatedUser,
              is_active: isActive,
              is_deleted: false,
            },
            () => {
              setIsEditModalOpen(false);
              const backdrop = document.querySelector('.modal-backdrop');
              if (backdrop) {
                backdrop.remove();
              }
              document.body.classList.remove('modal-open');
              document.body.style.overflow = '';
              document.body.style.paddingRight = '';
            },
          ),
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };


  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPartner((prevState) => ({ ...prevState, [name]: value }));
    setUpdatedUser((prevState: any) => ({ ...prevState, [name]: value }));
  };



  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    if (partnerUserCreated) {
      toast.current?.show({
        severity: 'success',
        summary: 'Success',
        detail: 'Partner is created successfully',
        life: 3000,
      });
      if (accessToken) {
        dispatch(getAllPartnerUsers());
      }
    }
  }, [partnerUserCreated]);

  useEffect(() => {
    if (selectedUser) {
      
      setUpdatedUser({
        id: selectedUser.id,
        first_name: selectedUser.first_name,
        last_name: selectedUser.last_name,
        email_address: selectedUser.email_address,
        phone_number: selectedUser.phone_number,
      });
    }
  }, [selectedUser]);

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    if (partnerUserUpdated) {
      toast.current?.show({
        severity: 'success',
        summary: 'Success',
        detail: 'Partner is updated successfully',
        life: 3000,
      });

      if (accessToken) {
        dispatch(getAllPartnerUsers());
      }
    }
  }, [partnerUserUpdated]);

  useEffect(() => {
    if (isError) {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: errorMessage || 'An error occurred',
        life: 3000,
      });
    }
  }, [isError, errorMessage]);

  return (
    <>
      <Toast ref={toast} />
      <div
        className={`modal fade ${isAddModalOpen ? 'show' : ''}`}
        id="add-user"
        style={{ display: isAddModalOpen ? 'block' : 'none' }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Partner</h5>
              <button
                type="button"
                className="btn-close close-modal"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setIsAddModalOpen(false)}
              >
                <Icon.X className="react-feather-custom"></Icon.X>
              </button>
            </div>
            <div className="modal-body pt-0">
              <form onSubmit={handleCreatePartnerUser}>
                <div className="mb-3 mt-3">
                  <label className="form-label">First Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="first_name"
                    value={partner.first_name}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Last Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="last_name"
                    value={partner.last_name}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Email Address</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email_address"
                    value={partner.email_address}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Phone Number</label>
                  <input
                    type="text"
                    className="form-control"
                    name="phone_number"
                    value={partner.phone_number}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="text-end">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={() => setIsAddModalOpen(false)}
                  >
                    Cancel
                  </button>
                  <button
                    disabled={isLoading}
                    type="submit"
                    className="btn btn-primary"
                  >
                    Add
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Edit Modal */}
      <div
        className={`modal fade ${isEditModalOpen ? 'show' : ''}`}
        id="edit-user"
        style={{ display: isEditModalOpen ? 'block' : 'none' }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Partner Update</h5>
              <button
                type="button"
                className="btn-close close-modal"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setIsEditModalOpen(false)}
              >
                <Icon.X className="react-feather-custom"></Icon.X>
              </button>
            </div>
            <div className="modal-body pt-0">
              <form onSubmit={handleUpdatePartnerUser}>
                <div className="mb-3">
                  <label className="form-label">First Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="first_name"
                    value={updatedUser.first_name}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Last Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="last_name"
                    value={updatedUser.last_name}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Email Address</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email_address"
                    value={updatedUser.email_address}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Phone Number</label>
                  <input
                    type="text"
                    className="form-control"
                    name="phone_number"
                    value={updatedUser.phone_number}
                    onChange={handleInputChange}
                  />
                </div>
 
                <div className="text-end">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={() => setIsAddModalOpen(false)}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PartnersModal;
